<template>
  <div>
    <v-row justify="center" v-if="show && dialog">
      <v-dialog v-model="dialog" max-width="400px" light>
        <v-card>
          <v-card-title>
            <span class="text-center headline w-100">
              {{ trans('Review activity') }} ({{ activity.name }})
            </span>
          </v-card-title>
          <v-card-text>
            <form ref="review">
              <div class="text-center">
                <div
                  v-if="unlockMoment"
                  v-html="
                    trans(`
                      In order to unlock this moment you have to leave a review for this
                      activity, after you write your review  refresh the page & the moment
                      should be unlocked.
                    `)
                  "
                ></div>
                <div
                  v-else
                  v-html="trans('Let us know how was your experience.')"
                ></div>
                <br />
                <v-rating
                  v-model="rating"
                  color="warning"
                  background-color="disabled"
                  large
                ></v-rating>
                <br />
                <v-textarea
                  v-model="review"
                  name="review"
                  outlined
                  dense
                  flat
                  :label="trans('Review')"
                  auto-grow
                  rows="3"
                  required
                ></v-textarea>
              </div>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              {{ trans('Close') }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="submit()"
              :loading="loading"
            >
              {{ trans('Review') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar">
        {{ snakMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: ['activity', 'csrf', 'unlockMoment'],
  data: () => ({
    dialog: true,
    rating: 0,
    snackbar: false,
    snakMessage: Vue.prototype.trans('Please click on starts to rate'),
    review: '',
    show: true,
    loading: false,
  }),
  methods: {
    submit() {
      if (this.rating == 0 || this.review.replace(/\s/g, '') == '') {
        return (this.snackbar = true);
      }

      this.loading = true;

      //submit form
      // send contact form data.
      axios
        .post(`/${window.lang}/reviews`, {
          rating: this.rating,
          review: this.review,
          activity_id: this.activity.id,
        })
        .then((_) => {
          this.loading = false;
          this.show = false;
          window.location.reload(true);
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
  },
  computed: {
    lang() {
      return window.lang;
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$emit('close');
      }
    },
  },
  created() {
    const oldReview = this.activity.reviews.find(
      (review) => review.user_id === this.$user.id,
    );
    if (oldReview) {
      this.review = oldReview.review;
      this.rating = oldReview.rating;
    }
  },
};
</script>
